<div class="col-12 px-0 px-xl-3">
	<app-atom-respondant-inline-list
		*ngIf="respondantSearchParams"
		[customLink]="customLink"
		[seeFullList]="false"
		[searchParams]="respondantSearchParams"
	></app-atom-respondant-inline-list>
</div>
